import { Employee } from 'features/authorized/components/portal/components/qr/common/core/entities/employee'

import photoIcon from 'assets/avatar-placeholder.svg'
import star from 'assets/star.svg'
import { useUser } from 'features/authorized/context/user';

const BodyRow = ({ employee, idx }: { employee: Employee; idx: number }) => {
    const { user: { currency } } = useUser()
    const { avatar, firstName, lastName, role, stars, tips } = employee

    const fullName = `${firstName} ${lastName}`

    const rowClass = ` group text-center ${idx % 2 === 0 ? 'bg-cream-30' : 'bg-cream-20'}`
    const cellClass = 'py-1.5'
    return (
        <tr key={idx} className={rowClass}>
            <td className="py-1.5 text-center text-grey-70">{idx + 1}</td>
            <td className={cellClass}>
                <div className="flex justify-center">
                    <img
                        className="h-10 w-10 rounded-full"
                        src={avatar || photoIcon}
                        alt={fullName}
                    />
                </div>
            </td>
            <td className={cellClass}>
                <div className="flex flex-col overflow-hidden text-left">
                    <div className="w-0 text-lg">{fullName}</div>
                    <div className="text-sm text-grey-10">{role}</div>
                </div>
            </td>
            <td className={cellClass}>
                <div className="flex items-center justify-center gap-2">
                    <img src={star} alt={'rating'} />
                    <div>{stars}</div>
                </div>
            </td>
            <td className={cellClass}>{tips / 100} {currency}</td>
        </tr>
    )
}

export default BodyRow
